import { render, staticRenderFns } from "./Branch-tile.vue?vue&type=template&id=97dbcc2c&scoped=true&"
import script from "./Branch-tile.vue?vue&type=script&lang=js&"
export * from "./Branch-tile.vue?vue&type=script&lang=js&"
import style0 from "./Branch-tile.vue?vue&type=style&index=0&id=97dbcc2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97dbcc2c",
  null
  
)

export default component.exports